import React from 'react';
import {DialogueProductPropTypes} from "../utils/propTypes.mjs";
import {productComponentClass} from "./DialogueProductWrapper";

const BasicProduct = ({ description, name, productUrl, productClassNames, productFeaturesAndDisclosuresRender, productActionsRender }) => {
    const componentClass = productComponentClass;

    return <div className={productClassNames}>
        <div className={`${componentClass}__title`}>
            <a href={productUrl} target="_blank"><h4>{ name }</h4></a>
        </div>
        <div className={`${componentClass}__details`}>
            <span className={`${componentClass}__description`}>{ description }</span>
            { productFeaturesAndDisclosuresRender }
            { productActionsRender }
        </div>
    </div>;
};

BasicProduct.propTypes = DialogueProductPropTypes;

export default BasicProduct;
